module.exports = __webpack_public_path__ + "img/Madhavji.e1082560.png";